import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, ProductCustomerDetails, TmsWebBaseEditCreateService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class ProductCustomerService extends TmsWebBaseEditCreateService<
  ProductCustomerDetails,
  ProductCustomerDetails
> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('ProductCustomer', $localize`Customer Products`, httpService, notificationService);
  }

  getForCustomer(id: string): Observable<ProductCustomerDetails[]> {
    return this.httpService.get<ProductCustomerDetails[]>(`${this.apiUrl}/CustomerProducts/${id}`);
  }
}
